import { Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import useCurrencySymbol from "../../hook/useCurrencySymbol";
import LoadingIcon from "../Loading/LoadingIcon";
import BalanceAmount from "./BalanceAmount";

const BalanceContent = ({
  balanceStyle,
  fontSize,
  hiddenSymbol,
  iconColor,
}) => {
  const gameBoxStatus = useSelector((state) => state.isGameBoxStatus);
  const currentCurrencySymbol = useCurrencySymbol();

  // default 預設值 playing 正在遊玩中 played 遊玩結束
  // 根據選擇的錢包幣別去取得isCurrencyExchange裡面對應的幣別符號

  useEffect(() => {
    if (gameBoxStatus == "played") {
      localStorage.setItem("played_time", dayjs());
    }
  }, [gameBoxStatus]);

  return (
    <Text
      fontSize={fontSize || "md"}
      fontWeight={`900`}
      mb={`0px`}
      display={`flex`}
      gap="5px"
      alignItems={`center`}
    >
      {hiddenSymbol ? null : (
        <Text fontWeight="400" color={iconColor || "#e6e7ed"}>
          {currentCurrencySymbol}
        </Text>
      )}
      <LoadingIcon size="xl" commonLoading={gameBoxStatus === "played"}>
        <BalanceAmount balanceStyle={balanceStyle} />
      </LoadingIcon>
    </Text>
  );
};

export default BalanceContent;
